export default __webpack_public_path__ + "static/media/blog05.66eb3a3f.png";